<template>
  <div class="cookie-consent">
    <div class="close">
      <i @click="closeBanner" class="material-symbols-outlined">close</i>
    </div>
    <div class="cookie-consent__content">
      <p>{{ message }}</p>
      <button @click="acceptCookies">{{ acceptText }}</button>
      <button @click="denyCookies">{{ denyText }}</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CookieConsent',
  data() {
    return {
      accepted: false,
    };
  },
  props: {
    message: {
      type: String,
      default: 'Vi använder cookies för att analysera trafik och händelser på vår webbplats med anonymiserade IP-adresser. Genom att fortsätta använda webbplatsen godkänner du vår användning av cookies.',
    },
    acceptText: {
      type: String,
      default: 'Acceptera',
    },
    denyText: {
      type: String,
      default: 'Neka',
    },
  },
  methods: {
    acceptCookies() {
      this.accepted = true;
      this.$emit('acceptCookies');
      document.dispatchEvent(new Event('cookieAccepted')); // Dispatch the cookieAccepted event
    },
    denyCookies() {
      this.$emit('denyCookies');
    },
    closeBanner() {
      this.$emit('closeBanner');
    },
  },
};
</script>

<style scoped>
.cookie-consent {
  position: fixed;
  bottom: 0;
  width: 100%;
  background-color: #f8f9fa;
  padding: 10px 20px;
  text-align: center;
  z-index: 99999;
}
.cookie-consent .close {
  width: 100%;
  text-align: right;
  margin: 10px auto;
}
.cookie-consent .close i {
  font-size: 24px;
  cursor: pointer;
  color: #007bff;
}
.cookie-consent .close:hover {
  color: #0056b3;
}

.cookie-consent__content {
  margin-bottom: 10px;
  max-width: 800px;
  margin: 10px auto;
}
.cookie-consent__content p {
  color: #007bff;
  margin: 10px auto;
}

.cookie-consent button {
  margin: 10px 5px;
  padding: 5px 10px;
  background-color: #007bff;
  color: #fff;
  border: none;
  cursor: pointer;
  width: 150px;
}
.cookie-consent button:hover {
  background-color: #0056b3;
}
</style>
